// Don't edit code here - edit it in src/gatsby-browser.ts
module.exports = require('./dist/gatsby-browser');
